import React, { useState } from "react";

import { API, graphqlOperation } from "aws-amplify";
import { deleteTask } from "../../../graphql/mutations";
import { updateAuditAssignee } from "../../../graphql/audit/custom-mutations";
import { performUpdateInboundMini } from "../../../graphql/inbound/inboundCRUD";
import { performUpdateOutboundMini } from "../../../graphql/outbound/outboundCRUD";

import { Button, Confirm } from "react-admin";

import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import classnames from "classnames";

import { DeleteIcon } from "../../../components/common/iconography";

import { logError } from "../../../utils/appUtils";
import { TaskType } from "../../../utils/constants";
import { deepRedirect } from "../../../utils/utils";

const useStyles = makeStyles(
  (theme) => ({
    deleteButton: {
      color: theme.palette.error.main,
      "&:hover": {
        backgroundColor: alpha(theme.palette.error.main, 0.12),
        // Reset on mouse devices
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },
  }),
  { name: "RaDeleteWithConfirmButton" },
);

export const DeepDeleteButton = ({
  record,
  backPath,
  history,
  notify,
  className,
  isSaving,
  isDeleting,
  setIsDeleting,
  ...props
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleDialogOpen = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  const handleDelete = async (event) => {
    setIsDeleting(true);
    let toUpdateRecord = null;
    debugger;

    try {
      const hasDependency = typeof record.reference === "string";

      debugger;
      if (hasDependency && record.category === TaskType.AUDIT) {
        toUpdateRecord = {
          id: record.reference,
          assignedTo: "",
        };
        await API.graphql(
          graphqlOperation(updateAuditAssignee, { input: toUpdateRecord }),
        );
      } else if (
        hasDependency &&
        record.category === TaskType.ACCEPT_SHIPMENT
      ) {
        toUpdateRecord = {
          id: record.reference,
          assignedTo: "",
        };
        await performUpdateInboundMini(toUpdateRecord);
      } else if (
        hasDependency &&
        record.category === TaskType.PROCESS_OUTBOUND_SHIPMENT
      ) {
        toUpdateRecord = {
          id: record.reference,
          assignedTo: "",
        };
        await performUpdateOutboundMini(toUpdateRecord);
      }
      toUpdateRecord = { id: record.id };

      await API.graphql(
        graphqlOperation(deleteTask, { input: toUpdateRecord }),
      );

      notify("Task deleted successfully", "success");
      deepRedirect(history, backPath);
    } catch (err) {
      logError(
        "tasks:DeepDeleteButton:handleDelete:" + JSON.stringify(toUpdateRecord),
        err,
        notify,
      );
    } finally {
      setIsDeleting(false);
      setOpen(false);
    }
  };

  return (
    <>
      <Button
        {...props}
        label="Delete"
        disabled={!record || isDeleting || isSaving}
        onClick={handleDialogOpen}
        className={classnames(
          "ra-delete-button",
          classes.deleteButton,
          className,
        )}
      >
        <DeleteIcon />
      </Button>
      <Confirm
        isOpen={open}
        loading={isDeleting}
        title={"Delete Confirmation"}
        content={"Are you sure you want to delete this Task?"}
        onConfirm={handleDelete}
        onClose={handleDialogClose}
      />
    </>
  );
};
